"use client"; // Error components must be Client Components

import H2 from "@/components/H2";
import Link from "next/link";
import { useEffect } from "react";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    // console.error(error);
  }, [error]);

  return (
    <div className="pt-50 grid place-content-center min-h-[50dvh] text-center">
      <H2>There was an error loading this content.</H2>
      <p>Please try again shortly.</p>
      <Link href="/">Return Home</Link>
    </div>
  );
}
